
export class SearchUtils {
  static normalizeForSearch(str: string | null): string {
    if(str == null || str.length <= 0) {
      return str ?? '';
    }

    return str.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}